/**
 * Backend may return a bare array or a wrapper object. Normalize to an array
 * so list/context code never treats a non-array as iterable.
 */
export function normalizeAnalyticProfilesResponse(data: unknown): Record<string, unknown>[] {
  if (Array.isArray(data)) {
    return data as Record<string, unknown>[];
  }
  if (data && typeof data === 'object') {
    const o = data as Record<string, unknown>;
    const keys = ['profiles', 'data', 'analytic_profiles', 'results', 'items'] as const;
    for (const k of keys) {
      const v = o[k];
      if (Array.isArray(v)) {
        return v as Record<string, unknown>[];
      }
    }
  }
  return [];
}

export function formatAnalyticProfileCreatedAt(iso: string | undefined | null): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return new Intl.DateTimeFormat('en-US', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(d);
}
